import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { categorySelectedTrigger, setDirectionDown } from './../../redux/actions';
import * as Scroll from 'react-scroll';
import { Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';
import { dropFirstItem } from './../../scripts';

class CategoryNavDesk extends Component {

  _changeCategory(category) {
    this.props.categorySelected(category);
    scroll.scrollTo(this.props.windowHeight, {
      duration: 350
    });
    const scrollHandle = () => {
      setTimeout(() => {this.props.setDirectionDown();}, 10);
    };
    Events.scrollEvent.register('end', () => {
      scrollHandle();
    });
  }

  render() {
    const navItems = dropFirstItem(this.props.Navigation).map((item, i) =>
      <li key={i} className={'category-menu-item-desktop'}>
        <Link to={`${this.props.Url}/${item.slug}`} className={(this.props.currentCategory == item.slug) ? 'category-button active' : 'category-button'} onClick={() => this._changeCategory(item.slug)}>
          <span>{item.name}</span>
        </Link>
      </li>
    );
    return (
      <menu className={'category-menu-desktop'}>
        <ul className={'category-nav-wrapper-desktop'}>
          {(this.props.Url == '/fine-art')
            ? <Link to={`${this.props.Url}`} className={'category-button active fine-art-nav'}>
                <span>select exhibitions</span>
              </Link>
            : <Fragment>
                <li className={'category-menu-item-desktop'}>
                  <Link to={`${this.props.Url}`} className={(this.props.currentCategory == 'everything') ? 'category-button active' : 'category-button'} onClick={() => this._changeCategory('everything')}>
                    <span>Everything</span>
                  </Link>
                </li>
                {navItems}
                {(this.props.Url == '/publications') &&
                  <li className={'category-menu-item-desktop'}>
                    <Link to={'/publications/stockists'} className={(this.props.currentCategory == 'stocklists') ? 'category-button active' : 'category-button'} onClick={() => this._changeCategory('stocklists')}>
                      <span>{'Stockists'}</span>
                    </Link>
                  </li>
                }
              </Fragment>
          }
        </ul>
      </menu>
    );
  }
};

export default connect(
  state => ({
    currentCategory: state.current_sub_category,
    currentCategorySlug: state.current_category_slug,
    windowHeight: state.window_dimensions.window_height
  }),
  dispatch => ({
    categorySelected: (category) => dispatch(categorySelectedTrigger(category)),
    setDirectionDown: () => dispatch(setDirectionDown())
  })
)(CategoryNavDesk);



// WEBPACK FOOTER //
// ./src/components/filter-pages/CategoryNavDesk.js